import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SubscriptionPlanStore } from "../pages/subscription/store/subscription-plan.store";
import { toObservable } from "@angular/core/rxjs-interop";
import { combineLatest, filter, map } from "rxjs";
import { Location } from "@angular/common";
import { AccessControlService } from '../pages/auth/services/access-control.service';

export const attendanceProductGuard: CanActivateFn = (route, state) => {
  const timesheets = /^\/home\/attendance\/(time-and-expenses|time-sheet)(?:[/?#]|$)/.test(state.url);
  const product = timesheets && inject(AccessControlService).timesheetImportOnly() ? 'Payroll' : 'CoreHR';
  return isProductActiveGuard(product)(route, state);
};

export const isProductActiveGuard = (product: string): CanActivateFn => {
  return (route, state) => {
    const subscriptionStore = inject(SubscriptionPlanStore);
    const router = inject(Router);
    const location = inject(Location);

    const isOnFreeTrial = toObservable(subscriptionStore.isOnFreeTrial);
    const subscriptionIsActiveForCurrentPeriod = toObservable(
      subscriptionStore.subscriptionIsActiveForCurrentPeriod,
    );
    const currentProducts = toObservable(subscriptionStore.currentProducts);

    return combineLatest({
      isOnFreeTrial,
      subscriptionIsActiveForCurrentPeriod,
      currentProducts,
    }).pipe(
      filter(
        ({ isOnFreeTrial, subscriptionIsActiveForCurrentPeriod }) =>
          isOnFreeTrial !== undefined &&
          subscriptionIsActiveForCurrentPeriod !== undefined,
      ),
      map(
        ({
          isOnFreeTrial,
          subscriptionIsActiveForCurrentPeriod,
          currentProducts: products,
        }) => {
          if (
            isOnFreeTrial === false &&
            subscriptionIsActiveForCurrentPeriod === false
          ) {
            return router.createUrlTree(["/home/403-forbidden"], {
              queryParams: {
                returnUrl: encodeURIComponent(location.path()),
                subscriptionExpired: true,
              },
            });
          }
          const productWithFeature = products.find(
            (prod) => prod.product.name == product,
          );

          if (
            products.length == 0 ||
            (productWithFeature && productWithFeature?.isEnabled)
          )
            return true;

          return router.createUrlTree(["/home/403-forbidden"], {
            queryParams: { returnUrl: encodeURIComponent(location.path()) },
          });
        },
      ),
    );
  };
};
